import React from 'react';
import { ClaimTabProps } from '../claim-registration';

const ClaimBinderDetails: React.FC<ClaimTabProps> = ({
  claim,
  includeNext,
  includeBack,
  navigateNext,
  navigateBack,
}) => {
  return (
    <div className="p-6 bg-white rounded-lg">
      <h2 className="mb-4 text-xl font-semibold">Claim Binder Details</h2>
      <p className="text-gray-500">
        Claim Binder Details content coming soon...
      </p>
    </div>
  );
};

export default ClaimBinderDetails;
